import { Listeners } from '@onereach/types-hitl-api';
const CALLBACK_TYPE = Listeners.CALLBACK_TYPE;
export { CALLBACK_TYPE };
//# sourceMappingURL=listeners.js.map